import React, { useEffect, useState, useMemo } from "react";
import { Spinner, Alert, Row, Col, Form, Button, Modal, Badge } from "react-bootstrap";
import { getNotificationLogs } from "../../services/adminApi";
import ReusableAdminTable from "./ReusableAdminTable"; // 👈 path adjust kar
import './AdminNotificationLogs.css'

const AdminNotificationLogs = () => {

  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [search, setSearch] = useState("");
  const [channelFilter, setChannelFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  // 🔥 FETCH DATA
  const fetchLogs = async () => {
    try {
      const res = await getNotificationLogs();
      setLogs(res.data.data || []);
      setFilteredLogs(res.data.data || []);
    } catch (err) {
      setError("Failed to load notification logs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  // 🔍 FILTER LOGIC
  useEffect(() => {
    let data = [...logs];

    if (search) {
      data = data.filter((log) =>
        (log.template_name || "")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }

    if (channelFilter) {
      data = data.filter((log) => log.channel === channelFilter);
    }

    if (statusFilter) {
      data = data.filter((log) => log.status === statusFilter);
    }

    setFilteredLogs(data);
  }, [search, channelFilter, statusFilter, logs]);

  // 📊 TABLE COLUMNS (ReusableAdminTable ke liye)
  const columns = useMemo(() => [
    {
      header: "#",
      cell: (info) => info.row.index + 1
    },
    {
      accessorKey: "user_id",
      header: "User"
    },
    {
      accessorKey: "template_name",
      header: "Template"
    },
    {
      accessorKey: "channel",
      header: "Channel",
      cell: (info) => <Badge bg="info">{info.getValue()}</Badge>
    },
    {
      accessorKey: "recipient",
      header: "Recipient"
    },
    {
      accessorKey: "subject",
      header: "Subject"
    },
    {
      id: "preview",
      header: "Preview",
      cell: (info) => (
        <Button
          size="sm"
          onClick={() => {
            setSelectedLog(info.row.original);
            setShowModal(true);
          }}
        >
          👁 View
        </Button>
      )
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: (info) => (
        <Badge
          bg={
            info.getValue() === "sent"
              ? "success"
              : info.getValue() === "failed"
              ? "danger"
              : "warning"
          }
        >
          {info.getValue()}
        </Badge>
      )
    },
    {
      accessorKey: "error_message",
      header: "Error"
    }
  ], []);

  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <div>

      {/* 🔍 FILTERS */}
      <Row className="mb-3">
       

        <Col md={3}>
          <Form.Select
            value={channelFilter}
            onChange={(e) => setChannelFilter(e.target.value)}
            className="dropdown-filter"
          >
            <option value="">All Channels</option>
            <option value="email">Email</option>
            <option value="sms">SMS</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="push">Push</option>
          </Form.Select>
        </Col>

        <Col md={3}>
          <Form.Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="dropdown-filter"
          >
            <option value="">All Status</option>
            <option value="sent">Sent</option>
            <option value="failed">Failed</option>
            <option value="pending">Pending</option>
          </Form.Select>
        </Col>
      </Row>

      {/* 🔥 REUSABLE TABLE */}
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <ReusableAdminTable
          data={filteredLogs}
          columns={columns}
          isLoading={loading}
          title="Notification Logs"
        />
      )}

      {/* 🔥 MODAL */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedLog?.subject || "Preview"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div
            style={{
              border: "1px solid #eee",
              borderRadius: "10px",
              padding: "15px",
              background: "#fff",
              maxHeight: "70vh",
              overflowY: "auto",
            }}
            dangerouslySetInnerHTML={{
              __html: selectedLog?.content || "",
            }}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default AdminNotificationLogs;